import React, { useState } from 'react'
import { Alert, Box, Button, Typography } from '@mui/material'
import { Check, Copy, Eye, EyeSlash } from '@phosphor-icons/react'
import { formatTemporaryAccessRemaining } from '../../helpers/helpers'
import useTemporaryAccessCountdown from '../../hooks/hooks'
import { TEMPORARY_ACCESS_TEXT } from '../../constants/temporaryAccessConstants'
import '../../../css/temporary_access.scss'

const TemporaryAccessCodeBox = ({ email, temporaryPassword, expiresAt }) => {
  const [visible, setVisible] = useState(false)
  const [copied, setCopied] = useState(false)
  const [copyError, setCopyError] = useState(false)
  const remainingMs = useTemporaryAccessCountdown(expiresAt)

  const handleCopy = async () => {
    setCopied(false)
    setCopyError(false)
    try {
      await navigator.clipboard.writeText(temporaryPassword)
      setCopied(true)
      window.setTimeout(() => setCopied(false), 2000)
    } catch {
      setCopyError(true)
    }
  }

  const expired = Boolean(expiresAt) && remainingMs === 0

  return (
    <Box className="temporary-access-code-box">
      <Typography className="temporary-access-user">
        <strong>{TEMPORARY_ACCESS_TEXT.user}</strong> {email}
      </Typography>
      <Typography className="temporary-access-password-label">
        {TEMPORARY_ACCESS_TEXT.password}
      </Typography>
      <Box className="temporary-access-code-row">
        <Typography component="div" className="temporary-access-code">
          {visible ? temporaryPassword : TEMPORARY_ACCESS_TEXT.maskedPassword}
        </Typography>
        <Box className="temporary-access-code-actions">
          <Button
            onClick={() => setVisible((current) => !current)}
            aria-pressed={visible}
            startIcon={visible ? <EyeSlash size={18} /> : <Eye size={18} />}
            className="temporary-access-text-button"
          >
            {visible ? TEMPORARY_ACCESS_TEXT.hide : TEMPORARY_ACCESS_TEXT.show}
          </Button>
          <Button
            onClick={handleCopy}
            startIcon={copied ? <Check size={18} /> : <Copy size={18} />}
            className="temporary-access-text-button"
          >
            {copied ? TEMPORARY_ACCESS_TEXT.copied : TEMPORARY_ACCESS_TEXT.copy}
          </Button>
        </Box>
      </Box>
      {copyError && <Alert severity="error">{TEMPORARY_ACCESS_TEXT.copyError}</Alert>}
      {expiresAt ? (
        <Typography
          className={`temporary-access-expiration${expired ? ' temporary-access-expiration--expired' : ''}`}
        >
          {TEMPORARY_ACCESS_TEXT.expiresIn} {formatTemporaryAccessRemaining(remainingMs)}
        </Typography>
      ) : null}
    </Box>
  )
}

export default TemporaryAccessCodeBox
